import { Component, OnInit, Injectable, Input, Output, NgZone } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

import { environment } from '../../environments/environment';
import { StorageService } from 'app/services/storage.service';
import { AuthWebService } from 'app/services/authweb.service';
import { AlertComponent } from 'app/popup/alert.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { SocialloginService } from '../services/sociallogin.service';
import { Socialusers } from '../models/socialusers';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

import { ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';


import {
	GoogleLoginProvider,
	FacebookLoginProvider,
	SocialAuthService,
	SocialUser,
  } from 'angular12-social-login';
import { timer } from 'rxjs';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IdleManagerService } from 'app/services/idle-manager.service';
import { SignalrService } from 'app/services/signalr.service';
import { CredentialResponse } from 'google-one-tap';

declare var async: any;
declare var jQuery: any;

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
	loadingpage: boolean = true;
	auth2: any;
	@ViewChild('loginRef', { static: true }) loginElement!: ElementRef;
reCaptcha: string = null;
	params: any = {};
  loginUser: any = { };
  aUser: any = {};
	systemCode: String = null;
	buildVersion : String = null;
	environment:string = null;
	user = "Haddad";
	sKey: string = null;
	hide: boolean = true;
	showCaptcha:boolean=false;
	correspondenceType:string = null;
	public isLoading = false;
	message = null;
	socialusers = new Socialusers();
	usergoogle: SocialUser;
	isreloaded: false;
	loggedIn: boolean;

	googleLoginOptions = {
		scope: 'profile email'
	  }; // https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2clientconfig
	  	dnnForm:any;
	

	constructor(public authWebservice: AuthWebService, private storageService: StorageService, private signalrService: SignalrService,
		private router: Router,private toastr: ToastrService,public OAuth: SocialAuthService, private SocialloginService: SocialloginService,
		private msalService:MsalService,private idleSrvc: IdleManagerService,
		//private helper: HelperService,
		private zone: NgZone
		//private route: ActivatedRoute
	)
	{
		
	}

	ngOnInit() {
		console.log("THe User Details old");

		if(this.signalrService.Isterminated || this.authWebservice.isloggedout ){
			location.reload();

		}

		

		// this.OAuth.initState.subscribe(value => {
		// 	this.OAuth.signIn(GoogleLoginProvider.PROVIDER_ID).then(user => {
		// 	  console.log('GoogleContainerComponent.ngOnInit user:', user)
		// 	});
		//   })
		   // @ts-ignore
		   
		
		// this.OAuth.authState.subscribe((user) => {
		// 	console.log("Auth User");
		// 	console.log(user);
		//   });
		
		// this.OAuth.authState.subscribe((user) => {
		// 	console.log(user);
		// 	this.loggedIn = (user != null);
		// 	this.OAuth.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID)
		//   });

		/*this.OAuth.initState.subscribe((user) => {
			
			this.loggedIn = (user != null);
			console.log("THe User Details");
			console.log(user);
			this.OAuth.signOut(true);
			this.OAuth.signOut();
			
		  });*/

		this.systemCode = environment.authWebApi.systemCode
		this.buildVersion = environment.name + '-' + environment.version;
		this.environment = environment.name;
		this.sKey = environment.captcha.siteKey;

		//this.OAuth.signOut();

		// this.googleAuthSDK();
			this.intialDnnForm();

			this.googleAuthSDK();  


	}

	async handleCredentialResponse(response: CredentialResponse) {
		debugger;
		console.log(response.toString());
	}

	signOut(): void {
		this.OAuth.signOut();
	  }
ngAfterViewInit(){
	setTimeout(()=>{this.showCaptcha=true;},500); 
}
intialDnnForm(){
	this.dnnForm = new UntypedFormGroup({
		DnnUsername: new UntypedFormControl(),
		DnnPassword: new UntypedFormControl(),
		
	});
}
submit(){
	this.isLoading = true;
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    form.classList.add('was-validated');
		var data ={
			username: this.dnnForm.value.DnnUsername,
			password: this.dnnForm.value.DnnPassword,
			systemcode: environment.authWebApi.systemCode
		}
		if(data.username === "" && data.password === ""){
			return;
		}
		document.getElementById('closeModal').click();
		this.authWebservice.loginWithDNN(data).subscribe((data:any) => {
			this.isLoading = false;
            if (data.IsAuthenticated) {
                environment.authWebApi.userData = data;
                this.storageService.setID(data.User.Id);
                this.storageService.setSessionId(data.User.Id);
                this.idleSrvc.setLoggedIn(data.IsAuthenticated);
                localStorage.setItem('isLogged','true');
                this.storageService.isLogged=true;
                let role:any=null;
                let userRoles:any=data.Roles.filter((map=>{return map.Code=='ADMIN'}));
                if(userRoles!=null && userRoles.length>0){
                   role='ADMIN'; 
                }else{
                  role='GUEST'
                }
        
                let previousUrl:any=localStorage.getItem("previousUrl")!=undefined ? localStorage.getItem("previousUrl") : sessionStorage.getItem("previousUrl")!=undefined ? sessionStorage.getItem("previousUrl") : undefined;
                if(previousUrl!=undefined && (previousUrl.indexOf('process')>0 || previousUrl.indexOf('approval')>0) && role!=null && role=='ADMIN'){
                  this.router.navigate([previousUrl]);
                  localStorage.removeItem('previousUrl');
                }else{
					this.router.navigate(['home']);
                }
		}
		else{
			return this.toastr.error('This user is not authenticated to use Cross Easy','Login failed');
		   }
			
		}, (error) => {
			//console.log(error);
			this.isLoading = false;
			// this.dialogService.addDialog(AlertComporrnent, { title: 'Registration failed', message: 'Contact the administrator if the problem persists.' });
			this.toastr.error('Contact the administrator if the problem persists.\n'+'\nTel : 012 471 2121'+'\nEmail: helpdesk@cbrta.co.za','Login failed');
		  });
  }

public callLogin() {


	// console.log("testing");
    // this.auth2.signOut().then(function () {
    //   console.log('User signed out.');
    // });
	// googleAuthUser.signOut().then(function () {
	// 	console.log('User signed out.');
	//   });
	
    this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
      (googleAuthUser: any) => {

        //Print profile details in the console logs
		// googleAuthUser.signOut().then(function () {
		// 	console.log('User signed out.');
		// });
	


        let profile = googleAuthUser.getBasicProfile();
        console.log('Token || ' + googleAuthUser.getAuthResponse().id_token);
        console.log('ID: ' + profile.getId());
        console.log('Name: ' + profile.getName());
        console.log('Image URL: ' + profile.getImageUrl());
        console.log('Email: ' + profile.getEmail());

		this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
		// this.aUser.UserCreated = this.aUser.UserUpdated = this.user;
		this.aUser.ActiveYN = true;
		//   this.isLoading = true;
		  //console.dir(this.aUser);
		this.aUser.UserName=profile.getEmail().toLowerCase();
		this.aUser.EmailAddress=profile.getEmail().toLowerCase();
		var SplittedName = profile.getName().split(" ");

		this.aUser.FirstName = SplittedName[1];
		this.aUser.LastName = SplittedName[0];
		this.aUser.Authenticator = "Google";
	console.log("User Data")
		console.log(this.aUser)
		
		this.zone.run(() => this.authWebservice.registersociallogin(this.aUser))

      }, (error: any) => {
        //alert(JSON.stringify(error, undefined, 2));
      });

  }
public googleAuthSDK() {
console.log("GOOGLE IN");
    (<any>window)['googleSDKLoaded'] = () => {
      (<any>window)['gapi'].load('auth2', () => {
        this.auth2 = (<any>window)['gapi'].auth2.getAuthInstance({
          //client_id: '42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com',
		  client_id: '922769349816-o4sujaq5m0gs033ilvneqj8taffa71qs.apps.googleusercontent.com',
          plugin_name:'login',
          cookiepolicy: 'single_host_origin',
          scope: 'profile email'
        });

         this.callLogin();
		
      });
    }

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement('script');
      js.id = id;
      js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
      fjs?.parentNode?.insertBefore(js, fjs);
    }(document, 'script', 'google-jssdk'));
  }

	login() {
		//alert('login');
		// if(this.reCaptcha === null && this.environment != 'qa' && this.environment != 'dev' && this.environment != 'cbrtauat'){			
		// 	return	this.toastr.warning('Are you a robot?','Recaptcha Warning');
		// }
        if(this.loginUser.UserName.toLowerCase().includes('@cbrta.co.za')){
			//alert('login2');
			return this.azureLogin();
		}
		this.loginUser.UserName=this.loginUser.UserName.toLowerCase();
		//alert(this.loginUser.UserName);
		this.authWebservice.login(this.loginUser.UserName, this.loginUser.Password);
		//alert(this.loginUser.Password);
	}
	
	regiser() {
		this.router.navigateByUrl('/register');
	}

	forgot() {
		this.router.navigateByUrl('/reset');
	}

	getSiteKey(){
			return this.sKey
	}

	resolved(captchaResponse: string){
		//console.log(captchaResponse)
		this.reCaptcha = captchaResponse;
	}

	showPassword() {
		this.hide = !this.hide;
	}

	 googlelogin(){

		//this.auth2.getAuthInstance().signOut();
        // this.auth2.signOut().then(function () {
        //     console.log('User signed out.');
        // });

	  this.auth2.attachClickHandler(this.loginElement.nativeElement, {},
      (googleAuthUser: any) => {

        //Print profile details in the console logs
		// googleAuthUser.signOut().then(function () {
		// 	console.log('User signed out.');
		// });
	
		console.log("testing");
    	this.auth2.signOut(true);
		
		localStorage.clear();
      	console.log('User signed out.');

        let profile = googleAuthUser.getBasicProfile();
		alert(profile);
        console.log('Token || ' + googleAuthUser.getAuthResponse().id_token);
        console.log('ID: ' + profile.getId());
        console.log('Name: ' + profile.getName());
        console.log('Image URL: ' + profile.getImageUrl());
        console.log('Email: ' + profile.getEmail());

		this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
		// this.aUser.UserCreated = this.aUser.UserUpdated = this.user;
		this.aUser.ActiveYN = true;
		//   this.isLoading = true;
		  //console.dir(this.aUser);
		this.aUser.UserName=profile.getEmail().toLowerCase();
		this.aUser.EmailAddress=profile.getEmail().toLowerCase();
		var SplittedName = profile.getName().split(" ");

		this.aUser.FirstName = SplittedName[1];
		this.aUser.LastName = SplittedName[0];
		this.aUser.Authenticator = "Google";
		console.log("User Data");
		alert(this.aUser);
		
		this.zone.run(() => this.authWebservice.registersociallogin(this.aUser));

      }, (error: any) => {
        //alert(JSON.stringify(error, undefined, 2));
      });
		}

	  signInWithGoogle(): void {
		// const googleLoginOptions = {
		// 	scope: 'profile email'
		//   }; // https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2clientconfig
		  
		// this.OAuth.signIn(GoogleLoginProvider.PROVIDER_ID,googleLoginOptions);
		this.OAuth.signIn(GoogleLoginProvider.PROVIDER_ID, this.googleLoginOptions).then(data =>{
			console.log(data)
		  });
	  }
	
	  signInWithFB(): void {
		this.OAuth.signOut();
		this.OAuth.signIn(FacebookLoginProvider.PROVIDER_ID);
	  }

	  public socialSignIn(socialProvider: string) {
		let authenticator = "";
		let socialPlatformProvider = '';
		if (socialProvider === 'facebook') {
		  socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
		  authenticator = "Facebook";
		} else if (socialProvider === 'google') {
		  socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
		  authenticator = "Google";
		}
	
		console.log("social ", socialPlatformProvider)
		//  signInWithGoogle(): void {
		//     this.authService.signIn(GoogleLoginProvider.PROVIDER_ID);
		//   }
	
		//   signInWithFB(): void {
		//     this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
		//   }
	
		// this.OAuth.signIn(GoogleLoginProvider.PROVIDER_ID);
	
		// this.OAuth.signIn(FacebookLoginProvider.PROVIDER_ID);
		
		this.OAuth.signIn(socialPlatformProvider).then(
		  (socialusers: SocialUser) => {
			console.log(socialProvider, socialusers);
			console.log(socialusers);
			// this.Savesresponse(socialusers);
			// this.form.value.FirstName = socialusers.firstName;
			// this.OAuth.signOut().then(function () =>{

			// })
	//     this.checkMobileNumber();
	
	// if (!this.numberisvalid )
	// {
	//   return this.toastr.warning('Please check the Mobile Number','Registration failed');
	// }
		
		this.aUser.DateCreated = this.aUser.DateUpdated = new Date();
		// this.aUser.UserCreated = this.aUser.UserUpdated = this.user;
		this.aUser.ActiveYN = true;
		//this.isLoading = true;
		//console.dir(this.aUser);
		if(socialusers.email != undefined){
			this.aUser.UserName=socialusers.email.toLowerCase();
			this.aUser.EmailAddress=socialusers.email.toLowerCase();
		  }else{
			this.aUser.UserName=socialusers.id.toLowerCase();
			this.aUser.EmailAddress=socialusers.id.toLowerCase();
		  }
		this.aUser.FirstName = socialusers.firstName;
		this.aUser.LastName = socialusers.lastName;
		this.aUser.Authenticator = authenticator;
		//console.log("User Data")
		//	console.log(this.aUser)
		this.authWebservice.registersociallogin(this.aUser);
		
		this.isLoading = false;
		  
		  }
		).catch(data => {
			this.OAuth.signOut();
			this.router.navigate(['login']);
		  });
	  }
	  azureLogin(){
	  	this.message = "Loading...";
		this.aUser.UserName=this.loginUser.UserName.toLowerCase();
		this.aUser.CommunicationType = this.correspondenceType === "2" ? "SMS" : "EMAIL";
		this.isLoading = true;
		//console.log(this.aUser);
		this.aUser.Password = this.loginUser.Password

		this.authWebservice.registerAzure(this.aUser);
		this.isLoading = false;
	  }
}
